type DirectoryUserLike = {
    businesses?: Array<Record<string, unknown>> | null
    assignments?: Array<Record<string, unknown>> | null
}

type OwnedCompanyLike = Array<Record<string, unknown>> | null | undefined

const normalizeValue = (value: unknown) => String(value ?? '').trim()

const resolveBusinessId = (item: Record<string, unknown>) =>
    normalizeValue(item.id ?? item.businessId ?? item.companyId)

const resolveBusinessName = (item: Record<string, unknown>) =>
    normalizeValue(item.brandName ?? item.name ?? item.companyName ?? item.businessName)

export const resolveBadgeCompanyName = (
    directoryUser: DirectoryUserLike | null | undefined,
    ownedCompanies?: OwnedCompanyLike,
    preferredBusinessId?: string | null,
) => {
    const normalizedPreferredBusinessId = normalizeValue(preferredBusinessId)
    const businesses = Array.isArray(directoryUser?.businesses) ? directoryUser.businesses : []
    const assignments = Array.isArray(directoryUser?.assignments) ? directoryUser.assignments : []
    const candidates = [...businesses, ...assignments]
    const normalizedOwnedCompanies = Array.isArray(ownedCompanies) ? ownedCompanies : []

    if (normalizedPreferredBusinessId) {
        const preferredOwnedCompany = normalizedOwnedCompanies.find(
            (item) => resolveBusinessId(item) === normalizedPreferredBusinessId,
        )
        const preferredOwnedCompanyName = preferredOwnedCompany ? resolveBusinessName(preferredOwnedCompany) : ''
        if (preferredOwnedCompanyName) return preferredOwnedCompanyName
    }

    if (normalizedPreferredBusinessId) {
        const preferred = candidates.find((item) => resolveBusinessId(item) === normalizedPreferredBusinessId)
        const preferredName = preferred ? resolveBusinessName(preferred) : ''
        if (preferredName) return preferredName
    }

    const firstNamedOwnedCompany = normalizedOwnedCompanies.find((item) => resolveBusinessName(item))
    if (firstNamedOwnedCompany) return resolveBusinessName(firstNamedOwnedCompany)

    const firstNamedCandidate = candidates.find((item) => resolveBusinessName(item))
    return firstNamedCandidate ? resolveBusinessName(firstNamedCandidate) : ''
}
